export default [
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register/index.vue'),
    meta: { pageName: 'Register', actionName: 'Register' }
  }
]
